import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar'; // adjust path as needed
import {
  FaDownload,
  FaSortUp,
  FaSortDown,
  FaChevronLeft,
  FaChevronRight,
  FaCheck,
  FaEye
} from 'react-icons/fa';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useScreenPermissions } from '../components/useScreenPermissions';
import ProjectViewModal from './ProjectViewModal';

const API_URL = '/api';

// Colors
const COLORS = {
  ANGEL: '#EAF9FB',      // screen background (light)
  THALASSA: '#D5F0F5',   // table header background
  TABLE_BODY: '#FFFFFF', // table body white
  SECTION_TITLE_BG: '#FFFFFF', // section title block
  SECTION_TITLE_TEXT: '#0f2b36', // section title text
  HEADER_TEXT_WHITE: '#ffffffff', // white text for table header
  DIVIDER: '#E6EEF2',    // divider color
};

const formatDate = (dateString) => {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'numeric',
    year: 'numeric'
  });
};

const ProjectItems = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [status, setStatus] = useState('All');
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedProject, setSelectedProject] = useState(null);
  const [showSkippedDetails, setShowSkippedDetails] = useState(false);



  const [viewModalOpen, setViewModalOpen] = useState(false); // <--- THIS WAS MISSING
  
  const navigate = useNavigate();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
  const { hasPermission, hasFullAccess, loading: permissionsLoading } = useScreenPermissions();

  // Stats state
  const [stats, setStats] = useState({
    totalProjects: 0,
    activeProjects: 0,
    blockedProjects: 0,
    createdThisMonth: 0,
  });

  // Sorting state
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(6);

  // Sync state
  const [isSyncing, setIsSyncing] = useState(false);
  const [showSyncSuccess, setShowSyncSuccess] = useState(false);
  const [syncData, setSyncData] = useState(null);

  // Fetch projects
  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
  try {
    setLoading(true);
    const response = await fetch(`${API_URL}/project-filter`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      }
    });

    if (!response.ok) throw new Error('Failed to fetch projects');

    const data = await response.json();
    
    // UPDATED: Removed the .map() parsing logic since 'Lines' is not coming from backend anymore
    setProjects(data); 
    
    calculateStats(data);
  } catch (error) {
    console.error('Error fetching projects:', error);
    alert('Error loading projects');
  } finally {
    setLoading(false);
  }
};

  const calculateStats = (projectList) => {
    const now = new Date();
    const currentMonth = now.getMonth();
    const currentYear = now.getFullYear();

    let totalProjects = projectList.length;
    let activeProjects = 0;
    let blockedProjects = 0;
    let createdThisMonth = 0;

    projectList.forEach((p) => {
      // Determine Blocked status
      const isBlocked = p.Blocked === 1 || p.Blocked === true;
      
      if (isBlocked) {
        blockedProjects++;
      } else {
        activeProjects++;
      }

      // Check if created this month
      const projDate = new Date(p.CreationDate);
      if (projDate.getMonth() === currentMonth && projDate.getFullYear() === currentYear) {
        createdThisMonth++;
      }
    });

    setStats({
      totalProjects,
      activeProjects,
      blockedProjects,
      createdThisMonth,
    });
  };

  const handleDownloadCSV = () => {
  // UPDATED: Removed 'Total Lines' from header
  let csvContent = 'Project No,Description,Customer Name,Person Responsible,Project Manager,Creation Date,Status\n';

  projects.forEach((p) => {
    // UPDATED: Removed totalLines variable
    const isBlocked = p.Blocked === 1 || p.Blocked === true;
    const status = isBlocked ? 'Blocked' : 'Active';
    const dateStr = new Date(p.CreationDate).toLocaleDateString();

    // UPDATED: Removed totalLines from the data row
    csvContent += `${p.No},"${p.Description || ''}","${p.BillToName || ''}","${p.BillToCustomerNo || ''}","${p.ProjectManager || ''}",${dateStr},${status}\n`;
  });

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', 'projects.csv');
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

 const handleSync = async () => {
  if (isSyncing) return;
  setIsSyncing(true);
  
  try {
    const res = await fetch(`${API_URL}/mapping/bc-projects/sync`, { method: 'GET' ,headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }});
    const data = await res.json();

    if (data.success) {
      // store sync results including skipped items
      setSyncData({
        totalHeaders: data.headersInserted + data.headersUpdated,
        headersInserted: data.headersInserted,
        headersUpdated: data.headersUpdated,
        totalLines: data.linesInserted + data.linesUpdated,
        linesInserted: data.linesInserted,
        linesUpdated: data.linesUpdated,
        skippedLines: data.skippedLines || []
      });
      setShowSyncSuccess(true);
      fetchProjects(); 
    } else {
      alert(`Sync Failed: ${data.message || 'Unknown error'}`);
    }
  } catch (error) {
    console.error("Sync Error:", error);
    alert("An error occurred while syncing projects.");
  } finally {
    setIsSyncing(false);
  }
};


    const handleView = (project) => {
    setSelectedProject(project.No); // Pass the Project Number (ID)
    setViewModalOpen(true); // This opens the modal
  };

  const handleLogout = () => {
    navigate('/login');
  };

  const handleDelete = async (projectNo) => {
    if (window.confirm(`Are you sure you want to delete Project ${projectNo}?`)) {
      alert('Delete functionality not implemented in backend yet.');
    }
  };

  const toggleStatus = async (projectNo, currentStatus) => {
    try {
      alert(`Toggle status for ${projectNo} - Status: ${currentStatus ? 'Blocked' : 'Active'}`);
    } catch (error) {
      console.error('Error updating project status:', error);
    }
  };

  // Handle sorting
  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  // Get sorted data
  const getSortedData = (data) => {
  if (!sortConfig.key) return data;

  return [...data].sort((a, b) => {
    let aValue, bValue;

    switch (sortConfig.key) {
      case 'No':
      case 'Description':
      case 'BillToName':
      case 'BillToCustomerNo':
      case 'BillToContact':
        aValue = a[sortConfig.key] || '';
        bValue = b[sortConfig.key] || '';
        break;
      case 'CreationDate':
        aValue = new Date(a[sortConfig.key]);
        bValue = new Date(b[sortConfig.key]);
        break;
      // REMOVED: 'totalLines' case block
      case 'Blocked':
        aValue = a.Blocked ? 1 : 0;
        bValue = b.Blocked ? 1 : 0;
        break;
      default:
        aValue = a[sortConfig.key];
        bValue = b[sortConfig.key];
    }

    if (aValue < bValue) {
      return sortConfig.direction === 'asc' ? -1 : 1;
    }
    if (aValue > bValue) {
      return sortConfig.direction === 'asc' ? 1 : -1;
    }
    return 0;
  });
};

  // Filter projects based on search term and status
  const filteredProjects = projects.filter((p) => {
    const matchesSearch =
      p.No.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (p.Description && p.Description.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (p.BillToName && p.BillToName.toLowerCase().includes(searchTerm.toLowerCase()));

    const isBlocked = p.Blocked === 1 || p.Blocked === true;
    const matchesStatus = status === 'All' || 
                          (status === 'Active' && !isBlocked) || 
                          (status === 'Blocked' && isBlocked);

    return matchesSearch && matchesStatus;
  });

  // Get sorted data
  const sortedProjects = getSortedData(filteredProjects);

  // Pagination logic
  const totalPages = Math.ceil(sortedProjects.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentItems = sortedProjects.slice(startIndex, endIndex);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Helper function to render sort arrows
  const renderSortArrows = (columnName) => {
    const isSorted = sortConfig.key === columnName;
    const isAsc = isSorted && sortConfig.direction === 'asc';
    const isDesc = isSorted && sortConfig.direction === 'desc';

    return (
      <span className="ml-2 flex flex-col">
        <FaSortUp className={`h-3 w-3 ${isAsc ? 'text-slate-800' : 'text-slate-400'}`} />
        <FaSortDown className={`h-3 w-3 -mt-1.5 ${isDesc ? 'text-slate-800' : 'text-slate-400'}`} />
      </span>
    );
  };

  // Render pagination buttons
  const renderPaginationButtons = () => {
    const buttons = [];
    const start = Math.max(1, currentPage - 2);
    const end = Math.min(totalPages, currentPage + 2);

    buttons.push(
      <button
        key="prev"
        onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
        disabled={currentPage === 1}
        className={`p-2 transition-all duration-200 ${
          currentPage === 1 ? 'text-slate-300 cursor-not-allowed' : 'text-slate-800 hover:bg-slate-100'
        } rounded-none`}
      >
        <FaChevronLeft className="h-5 w-5" />
      </button>
    );

    for (let i = start; i <= end; i++) {
      buttons.push(
        <button
          key={i}
          onClick={() => setCurrentPage(i)}
          className={`px-4 py-1 font-medium transition-all duration-200 ${
            i === currentPage
              ? 'bg-blue-500 text-white rounded-none'
              : 'text-slate-800 hover:bg-slate-100 rounded-none'
          }`}
        >
          {i}
        </button>
      );
    }

    buttons.push(
      <button
        key="next"
        onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
        disabled={currentPage === totalPages || totalPages === 0}
        className={`p-2 transition-all duration-200 ${
          currentPage === totalPages || totalPages === 0 ? 'text-slate-300 cursor-not-allowed' : 'text-slate-800 hover:bg-slate-100'
        } rounded-none`}
      >
        <FaChevronRight className="h-5 w-5" />
      </button>
    );

    return buttons;
  };

  // Check permissions for actions
  const canCreate = hasFullAccess || hasPermission('PROJECT_LIST', 'CanCreate');
  const canView = hasFullAccess || hasPermission('PROJECT_LIST', 'CanView');
  const canEdit = hasFullAccess || hasPermission('PROJECT_LIST', 'CanEdit');
  const canDelete = hasFullAccess || hasPermission('PROJECT_LIST', 'CanDelete');

  if (permissionsLoading) {
    return (
      <div className="flex h-screen items-center justify-center" style={{ backgroundColor: COLORS.ANGEL }}>
        <div className="text-center">
          <div className="animate-spin h-12 w-12 border-t-4 border-b-4 border-slate-800 mx-auto rounded-full"></div>
          <p className="mt-4 text-lg font-medium text-slate-700">Loading permissions...</p>
        </div>
      </div>
    );
  }

  return (
    <div
      className="min-h-screen flex"
      style={{
        backgroundColor: COLORS.ANGEL,
        '--accent-color': '#0f766e',
        '--accent-hover': '#2b8f85',
        '--hover-gray': '#f1f5f9',
        '--page-border-color': COLORS.DIVIDER,
        '--sidebar-bg': '#ffffff',
        '--page-background': COLORS.ANGEL
      }}
    >
      <Sidebar
        collapsed={sidebarCollapsed}
        onToggle={setSidebarCollapsed}
        theme={{ activeBg: '#4f8ef5ff', activeText: '#ffffffff', profileBg: '#4f8ef5ff' }}
        onLogout={handleLogout}
      />
      <main
        className={`flex-1 p-6 lg:p-8 overflow-hidden transition-all duration-300 ${sidebarCollapsed ? 'lg:ml-[90px]' : 'lg:ml-[280px]'}`}
      >
        {/* Header */}
        <header>
          <div className="mb-8">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
              <div>
                <h1 className="text-3xl font-bold text-dark-500 mb-2">
                  Projects
                </h1>
                <p className="text-gray-600">
                  Manage your projects here.
                </p>
              </div>
              <div className="flex items-center gap-3">
                {/* Sync Button */}
                <button 
                  onClick={handleSync} 
                  disabled={isSyncing}
                  className={`flex items-center gap-2 px-4 py-2 rounded-none font-medium transition-all duration-200 border ${
                    isSyncing 
                      ? 'bg-gray-100 text-gray-500 cursor-not-allowed border-gray-300' 
                      : 'bg-white text-blue-600 border-blue-200 hover:bg-blue-50'
                  }`}
                >
                  {isSyncing ? (
                    <>
                      <svg className="animate-spin h-4 w-4 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      Syncing...
                    </>
                  ) : (
                    <>
                      <FaCheck className="h-4 w-4" />
                      Sync 
                    </>
                  )}
                </button>

                <button onClick={handleDownloadCSV} className="flex items-center gap-2 rounded-none border border-slate-200 px-3 py-2 bg-white text-slate-800 hover:bg-slate-50 transition-all duration-200"><FaDownload className="w-4 h-4" />Export</button>
              </div>
            </div>
            <div style={{ height: 1, backgroundColor: COLORS.DIVIDER, marginTop: 16, marginBottom: 20 }} />
          </div>
        </header>

        {/* Stats Cards */}
        {/* <section className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
          <div className="p-5 bg-white border border-slate-200 shadow-sm hover:shadow-md transition-shadow duration-200 rounded-none">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-slate-600">Total Projects</p>
                <p className="text-2xl font-semibold text-slate-900">{stats.totalProjects}</p>
              </div>
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-slate-100 text-slate-800">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                </svg>
              </div>
            </div>
          </div>

          <div className="p-5 bg-white border border-slate-200 shadow-sm hover:shadow-md transition-shadow duration-200 rounded-none">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-slate-600">Active Projects</p>
                <p className="text-2xl font-semibold text-slate-900">{stats.activeProjects}</p>
              </div>
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-teal-50 text-teal-700">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
            </div>
          </div>

          <div className="p-5 bg-white border border-slate-200 shadow-sm hover:shadow-md transition-shadow duration-200 rounded-none">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-slate-600">Blocked Projects</p>
                <p className="text-2xl font-semibold text-slate-900">{stats.blockedProjects}</p>
              </div>
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-amber-50 text-amber-700">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
            </div>
          </div>

          <div className="p-5 bg-white border border-slate-200 shadow-sm hover:shadow-md transition-shadow duration-200 rounded-none">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-slate-600">Created This Month</p>
                <p className="text-2xl font-semibold text-slate-900">{stats.createdThisMonth}</p>
              </div>
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-slate-100 text-slate-800">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </div>
            </div>
          </div>
        </section> */}

        {/* Search & Filter */}
        <section className="p-5 bg-white border border-slate-200 shadow-sm mb-6 rounded-none">
          <div className="flex flex-col md:flex-row gap-3 items-end">
            <div className="flex-1">
              <label className="block text-sm font-medium text-slate-700 mb-1">Search</label>
              <input
                type="text"
                placeholder="Search Project No, Description, Customer..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full px-4 py-2 bg-white border border-slate-200 text-slate-800 focus:outline-none focus:ring-2 focus:ring-slate-300 transition-all duration-200 rounded-none"
              />
            </div>
            {/* <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Status</label>
              <select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                className="px-4 py-2 bg-white border border-slate-200 text-slate-800 focus:outline-none focus:ring-2 focus:ring-slate-300 transition-all duration-200 rounded-none"
              >
                <option value="All">All</option>
                <option value="Active">Active</option>
                <option value="Blocked">Blocked</option>
              </select>
            </div> */}
            <button
              className="px-5 py-2 bg-blue-500 text-white font-medium hover:bg-blue-400 transition-all duration-200 shadow rounded-none"
              onClick={() => fetchProjects()}
            >
              Search
            </button>
          </div>
        </section>

        {/* Table */}
        <section className="shadow-sm overflow-hidden rounded-none border border-slate-200">
          {/* Section Title */}
          <div
            className="flex justify-between items-center p-4"
            style={{ backgroundColor: COLORS.SECTION_TITLE_BG, borderBottom: `1px solid ${COLORS.DIVIDER}` }}
          >
            <h2 className="text-xl font-semibold" style={{ color: COLORS.SECTION_TITLE_TEXT }}>
              Projects
            </h2>
            <div className="flex gap-2">{renderPaginationButtons()}</div>
          </div>

          {loading ? (
            <div className="p-8 text-center text-slate-600">Loading projects...</div>
          ) : sortedProjects.length === 0 ? (
            <div className="p-8 text-center text-slate-600">No projects found</div>
          ) : (
            <div className="overflow-x-auto" style={{ backgroundColor: COLORS.TABLE_BODY }}>
              <table className="w-full text-sm" style={{ backgroundColor: COLORS.TABLE_BODY }}>
                <thead style={{ backgroundColor: COLORS.THALASSA }} className="text-gray-600 text-xs text-left font-semibold uppercase">
                  <tr>
                    <th className="px-6 py-3 text-left cursor-pointer transition-colors duration-200 text-gray-600" onClick={() => handleSort('No')}>
                      <div className="flex items-center">Project No {renderSortArrows('No')}</div>
                    </th>
                    <th className="px-6 py-3 text-left cursor-pointer transition-colors duration-200 text-gray-600" onClick={() => handleSort('Description')}>
                      <div className="flex items-center">Description {renderSortArrows('Description')}</div>
                    </th>
                    <th className="px-6 py-3 text-left cursor-pointer transition-colors duration-200 text-gray-600" onClick={() => handleSort('BillToName')}>
                      <div className="flex items-center">Customer Name {renderSortArrows('BillToName')}</div>
                    </th>
                    <th className="px-6 py-3 text-left cursor-pointer transition-colors duration-200 text-gray-600" onClick={() => handleSort('BillToCustomerNo')}>
                      <div className="flex items-center">Bill To Customer No {renderSortArrows('BillToCustomerNo')}</div>
                    </th>
                    <th className="px-6 py-3 text-left cursor-pointer transition-colors duration-200 text-gray-600" onClick={() => handleSort('BillToContact')}>
                      <div className="flex items-center">Bill To Contact {renderSortArrows('BillToContact')}</div>
                    </th>
                    <th className="px-6 py-3 text-left cursor-pointer transition-colors duration-200 text-gray-600" onClick={() => handleSort('CreationDate')}>
                      <div className="flex items-center">Creation Date {renderSortArrows('CreationDate')}</div>
                    </th>
                    {/* <th className="px-6 py-3 text-left cursor-pointer transition-colors duration-200 text-gray-600" onClick={() => handleSort('totalLines')}>
                      <div className="flex items-center">Total Lines {renderSortArrows('totalLines')}</div>
                    </th> */}
                    {/* <th className="px-6 py-3 text-left cursor-pointer transition-colors duration-200 text-gray-600" onClick={() => handleSort('Blocked')}>
                      <div className="flex items-center">Status {renderSortArrows('Blocked')}</div>
                    </th> */}
                    <th className="px-6 py-3 text-center text-gray-600">Actions</th>
                  </tr>
                </thead>

                <tbody className="divide-y" style={{ borderColor: COLORS.DIVIDER }}>
                  {currentItems.map((p) => {
                    const totalLines = p.Lines ? p.Lines.length : 0;
                    const isBlocked = p.Blocked === 1 || p.Blocked === true;
                    const statusText = isBlocked ? 'Blocked' : 'Active';

                    return (
                      <tr key={p.ProjectHeaderId || p.No} className="hover:bg-white/70 transition-colors duration-200">
                        <td className="px-6 py-3 text-left font-medium text-slate-900" style={{ backgroundColor: COLORS.TABLE_BODY }}>
                          {p.No}
                        </td>
                        <td className="px-6 py-3 text-left text-slate-700 truncate max-w-xs" style={{ backgroundColor: COLORS.TABLE_BODY }} title={p.Description}>
                          {p.Description || '-'}
                        </td>
                        <td className="px-6 py-3 text-left text-slate-700 uppercase" style={{ backgroundColor: COLORS.TABLE_BODY }}>
                          {p.BillToName || '-'}
                        </td>
                        <td className="px-6 py-3 text-left text-slate-700" style={{ backgroundColor: COLORS.TABLE_BODY }}>
                          {p.BillToCustomerNo || '-'}
                        </td>
                        <td className="px-6 py-3 text-left text-slate-700" style={{ backgroundColor: COLORS.TABLE_BODY }}>
                          {p.BillToContact || '-'}
                        </td>
                        <td className="px-6 py-3 text-left text-slate-700" style={{ backgroundColor: COLORS.TABLE_BODY }}>
                          {formatDate(p.CreationDate)}
                        </td>
                        {/* <td className="px-6 py-3 text-left text-slate-700" style={{ backgroundColor: COLORS.TABLE_BODY }}>
                          {totalLines}
                        </td> */}
                        {/* <td className="px-6 py-3" style={{ backgroundColor: COLORS.TABLE_BODY }}>
                          <span
                            className={`inline-block px-3 py-1 text-xs font-medium cursor-pointer transition-colors duration-200 ${
                              isBlocked ? 'bg-amber-50 text-amber-700 hover:bg-amber-100' : 'bg-teal-50 text-teal-700 hover:bg-teal-100'
                            } rounded-full`}
                            onClick={() => toggleStatus(p.No, isBlocked)}
                            title={`Click to ${isBlocked ? 'unblock' : 'block'}`}
                          >
                            {statusText}
                          </span>
                        </td> */}
                        <td className="px-6 py-3" style={{ backgroundColor: COLORS.TABLE_BODY }}>
                          <div className="flex gap-3 justify-center">
                            {canView && (
                              <button
                                onClick={() => handleView(p)}
                                className="text-slate-800 hover:text-slate-900 transition-colors duration-200 rounded-none p-1"
                                title="View"
                              >
                                <FaEye className="h-4 w-4" />
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </section>

        {/* Sync Success Modal */}
       {showSyncSuccess && syncData && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4 overflow-auto ">
    <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6 text-center transform transition-all scale-100">
      <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100 mb-4">
        <FaCheck className="h-8 w-8 text-green-600" />
      </div>

      <h3 className="text-2xl font-bold text-gray-900 mb-2">Sync Complete!</h3>
      <p className="text-gray-500 mb-4">
        Projects have been successfully synchronized.
      </p>

      {syncData.skippedLines.length > 0 && (
        <div className="mt-4 p-3 bg-yellow-50 border border-yellow-200 rounded text-left text-sm text-yellow-800">
          <p>
            ⚠ Some items or locations were skipped because they do not exist in your master data. 
            You need to sync your <strong>ProductMaster</strong> and <strong>LocationMaster</strong> to see all lines.
          </p>

          <button
            className="mt-2 text-blue-600 hover:underline text-sm"
            onClick={() => setShowSkippedDetails(!showSkippedDetails)}
          >
            {showSkippedDetails ? 'Hide Details' : 'View Details'}
          </button>

          {showSkippedDetails && (
            <div className="mt-2 max-h-64 overflow-y-auto border border-yellow-200 rounded">
              <table className="w-full text-sm text-left border-collapse">
                <thead className="bg-yellow-100">
                  <tr>
                    <th className="px-3 py-2 border-b border-yellow-200">Job No</th>
                    <th className="px-3 py-2 border-b border-yellow-200">Line No</th>
                    <th className="px-3 py-2 border-b border-yellow-200">Item</th>
                    <th className="px-3 py-2 border-b border-yellow-200">Location</th>
                    <th className="px-3 py-2 border-b border-yellow-200">Reason</th>
                  </tr>
                </thead>
                <tbody>
                  {syncData.skippedLines.map((line, idx) => (
                    <tr key={idx} className="hover:bg-yellow-50">
                      <td className="px-3 py-2 border-b border-yellow-200">{line.jobNo || '-'}</td>
                      <td className="px-3 py-2 border-b border-yellow-200">{line.lineNo || '-'}</td>
                      <td className="px-3 py-2 border-b border-yellow-200">{line.item || '-'}</td>
                      <td className="px-3 py-2 border-b border-yellow-200">{line.location || '-'}</td>
                      <td className="px-3 py-2 border-b border-yellow-200">{line.reason}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      <button
        onClick={() => setShowSyncSuccess(false)}
        className="mt-6 w-full inline-flex justify-center items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-500 shadow-sm hover:bg-blue-400 focus:outline-none transition-all duration-200"
      >
        Close
      </button>
    </div>
  </div>
)}

        {/* Project View Modal */}
<ProjectViewModal 
  open={viewModalOpen} 
  onClose={() => setViewModalOpen(false)} 
  projectId={selectedProject} 
/>

      </main>

    </div>
  );
};

export default ProjectItems;